import { useTransformSectionToGoalMutation } from 'shared/hooks/queries/use-transform-section-to-goal-mutation';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';

export type TransformSectionToGoalOptions = {
  goal: Goal;
  isSubGoal?: boolean;
};

export const useTransformSectionToGoal = () => {
  const { mutateAsync } = useTransformSectionToGoalMutation();
  return (sectionId: ID, { goal, isSubGoal }: TransformSectionToGoalOptions) =>
    mutateAsync({ goal, sectionId, isSubGoal });
};
